import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const MicklehamEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Mickleham" suburbSlug="mickleham" variant="emergency-dentist" />
);

export default MicklehamEmergencyDentistPage;
